import Cookies from "js-cookie";

import { COOKIE_EXPIRES, JWT_COOKIE } from "~/const-files/const";

/**
 * Domeny, na ktere se drive nastavovala jwt cookie (".host", u subdomen i ".makuderovi.cz").
 * Cookie s domenou se posila i na vsechny subdomeny - jwt z makuderovi.cz pak chodilo i na roman. a lenka.
 */
function getLegacyCookieDomains() {
	const parts = location.hostname.split(".");

	return parts
		.map((_part, ind) => parts.slice(ind).join("."))
		// bez samotne TLD
		.filter(domain => domain.includes("."))
		.map(domain => `.${domain}`);
}

export function setJwtCookie(jwt: string) {
	// host-only (bez domain) - cookie plati jen pro aktualni domenu, ne pro subdomeny
	Cookies.set(JWT_COOKIE, jwt, {
		expires: COOKIE_EXPIRES,
		sameSite: "Strict",
		path: "/",
		secure: location.protocol === "https:",
	});
}

export function removeJwtCookie() {
	Cookies.remove(JWT_COOKIE, { path: "/" });

	for (const domain of getLegacyCookieDomains()) {
		Cookies.remove(JWT_COOKIE, { path: "/", domain });
	}
}

/** Prevede starou domenovou cookie na host-only, cizi (rodicovskou) smaze - jinak by PHP vzalo jwt jineho webu. */
function migrateJwtCookie() {
	const ownDomain = `.${location.hostname}`;

	for (const domain of getLegacyCookieDomains()) {
		if (domain !== ownDomain) {
			Cookies.remove(JWT_COOKIE, { path: "/", domain });
		}
	}

	// zbyla jen vlastni stara a/nebo nova cookie
	const jwt = Cookies.get(JWT_COOKIE);

	Cookies.remove(JWT_COOKIE, { path: "/", domain: ownDomain });
	jwt && setJwtCookie(jwt);
}

/** Vola se pri startu aplikace, pred auth. */
export function getJwtCookie() {
	migrateJwtCookie();

	return Cookies.get(JWT_COOKIE);
}
